webpackJsonp([12],{

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__feathers___ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n___ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_turf_distance__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_turf_distance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_turf_distance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_debounce__);












__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    uri: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].io.io.uri,
    feathers: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */],
    posInterval: null,
    loading: true,
    fetching: false,
    auth: {
      user: null,
      token: null,
      geolocation: {
        position: {
          lat: 44.4472043,
          lng: 26.0917751
        }
      }
    },
    snacks: {
      messages: [],
      visible: false
    },
    notifications: [],
    app: {
      light: new Date().getHours() > 7 && new Date().getHours() < 21,
      clipped: true,
      fixed: true,
      drawer: true,
      mini: false,
      menuItems: [{ icon: 'home', title: 'Acasa', link: '/' }, { icon: 'vpn_key', title: 'Login', link: '/login', auth: false }, { icon: 'dashboard', title: 'Panou de control', link: '/dashboard', auth: true, admin: true }]
    },
    admin: {
      users: {
        data: [],
        search: '',
        page: 1,
        totalPages: 1,
        sort: {
          username: 1
        }
      },
      requests: {
        data: [],
        page: 1,
        totalPages: 1,
        sort: {
          createdAt: -1
        }
      }
    },
    addresses: {
      mine: {
        data: [],
        search: '',
        page: 1,
        totalPages: 1,
        sort: {
          nrcrt: 1
        },
        done: 0,
        google: 0,
        images: 0
      },
      all: {
        data: [],
        search: '',
        page: 1,
        totalPages: 1,
        sort: {
          nrcrt: 1
        },
        access: 0,
        done: 0,
        google: 0,
        images: 0
      },
      loading: false
    },
    photos: {},

    archives: {
      data: [],
      page: 1,
      totalPages: 1,
      sort: {
        createdAt: -1
      }
    },

    addresses4map: [],
    myaddresses4map: [],
    users4map: [],
    messages: {},
    pdfmessages: {},

    services: {
      users: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('users'),
      addresses: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('addresses'),
      photos: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('photos'),
      pdfs: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('pdfs'),
      requests: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('requests'),
      archives: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('downloads'),
      xlsx: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('xlsx'),
      histories: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('histories'),
      messages: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('messages'),
      thumbgenerator: __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('thumbgenerator')
    }
  },
  getters: {
    uri: function uri(state) {
      return state.uri;
    },
    snacksVisible: function snacksVisible(state) {
      return state.snacks.visible;
    },
    snacksMessages: function snacksMessages(state) {
      return state.snacks.messages;
    },
    appLight: function appLight(state) {
      return state.app.light;
    },
    appFixed: function appFixed(state) {
      return state.app.fixed;
    },
    appDrawer: function appDrawer(state) {
      return state.app.drawer;
    },
    appMini: function appMini(state) {
      return state.app.mini;
    },
    appClipped: function appClipped(state) {
      return state.app.clipped;
    },
    appMenuItems: function appMenuItems(state) {
      return state.app.menuItems;
    },
    getUser: function getUser(state) {
      return state.auth.user;
    },
    getLocation: function getLocation(state) {
      return state.auth.geolocation.position;
    },
    getLoading: function getLoading(state) {
      return state.loading;
    },
    getFetching: function getFetching(state) {
      return state.fetching;
    },
    getNotifications: function getNotifications(state) {
      return state.notifications;
    },

    getAllUsers: function getAllUsers(state) {
      return state.admin.users;
    },
    getUsersPage: function getUsersPage(state) {
      return state.admin.users.page;
    },
    getUsersSearch: function getUsersSearch(state) {
      return state.admin.users.search;
    },

    getAllRequests: function getAllRequests(state) {
      return state.admin.requests;
    },
    getRequestsPage: function getRequestsPage(state) {
      return state.admin.requests.page;
    },

    getAllMyAddresses: function getAllMyAddresses(state) {
      return state.addresses.mine;
    },
    getMyAddressesPage: function getMyAddressesPage(state) {
      return state.addresses.mine.page;
    },
    getMyAddressesSearch: function getMyAddressesSearch(state) {
      return state.addresses.mine.search;
    },

    getAllAddresses: function getAllAddresses(state) {
      return state.addresses.all;
    },
    getAllAddressesPage: function getAllAddressesPage(state) {
      return state.addresses.all.page;
    },
    getAllAddressesSearch: function getAllAddressesSearch(state) {
      return state.addresses.all.search;
    },

    getAddresses4Map: function getAddresses4Map(state) {
      return state.addresses4map;
    },
    getMyAddresses4Map: function getMyAddresses4Map(state) {
      return state.myaddresses4map;
    },
    getUsers4Map: function getUsers4Map(state) {
      return state.users4map;
    },

    getArchives: function getArchives(state) {
      return state.archives;
    },
    getArchivesPage: function getArchivesPage(state) {
      return state.archives.page;
    },

    addressLoading: function addressLoading(state) {
      return state.addresses.loading;
    },

    myAddDone: function myAddDone(state) {
      return state.addresses.mine.done;
    },
    myAddGoogle: function myAddGoogle(state) {
      return state.addresses.mine.google;
    },
    myAddImages: function myAddImages(state) {
      return state.addresses.mine.images;
    },

    addDone: function addDone(state) {
      return state.addresses.all.done;
    },
    addGoogle: function addGoogle(state) {
      return state.addresses.all.google;
    },
    addAccess: function addAccess(state) {
      return state.addresses.all.access;
    },
    addImages: function addImages(state) {
      return state.addresses.all.images;
    },

    messages: function messages(state) {
      return state.messages;
    },
    pdfmessages: function pdfmessages(state) {
      return state.pdfmessages;
    }
  },
  mutations: {
    setPosInterval: function setPosInterval(state, data) {
      if (state.posInterval) {
        clearInterval(state.posInterval);
      }
      state.posInterval = data;
    },
    setLoading: function setLoading(state, data) {
      state.loading = data;
    },
    setFetching: function setFetching(state, data) {
      state.fetching = data;
    },
    setAuth: function setAuth(state, data) {
      state.auth.token = data.token;
      state.auth.user = data.user;
      state.auth.error = null;
      state.loading = false;
    },
    setGeolocationPosition: function setGeolocationPosition(state, position) {
      var _position$coords = position.coords,
          lat = _position$coords.latitude,
          lng = _position$coords.longitude;

      state.auth.geolocation.position = { lat: lat, lng: lng };
    },
    setSnack: function setSnack(state, data) {
      var copy = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.error));
      copy.meta = data.meta || null;
      copy.message = copy.meta && copy.meta.error && copy.code ? __WEBPACK_IMPORTED_MODULE_5__i18n___["a" /* errorMessages */][copy.code] : copy.message;
      if (copy.message) {
        state.snacks.messages.push(copy);
        state.snacks.visible = true;
      } else {}
    },
    toggleSnacks: function toggleSnacks(state, value) {
      state.snacks.visible = value;
    },
    removeSnack: function removeSnack(state) {
      state.snacks.messages.splice(0, 1);
    },
    toggleLight: function toggleLight(state) {
      state.app.light = !state.app.light;
    },
    closeDrawer: function closeDrawer(state) {
      state.app.drawer = false;
    },
    openDrawer: function openDrawer(state) {
      state.app.drawer = true;
    },
    toggleMini: function toggleMini(state) {
      state.app.mini = !state.app.mini;
    },
    clearMessages: function clearMessages(state) {
      state.snacks.messages = [];
      state.snacks.visible = false;
    },
    fillUsers: function fillUsers(state, data) {
      state.admin.users.data = data;
    },
    clearUsers: function clearUsers(state) {
      state.admin.users.data = [];
    },
    setUsersPage: function setUsersPage(state, page) {
      state.admin.users.page = page;
    },
    setUsersSort: function setUsersSort(state, sort) {
      state.admin.users.sort = sort;
    },
    setUsersSearch: function setUsersSearch(state, search) {
      state.admin.users.search = search;
    },
    fillMyAddresses: function fillMyAddresses(state, data) {
      state.addresses.mine.data = data;
    },
    clearMyAddresses: function clearMyAddresses(state) {
      state.addresses.mine.data = [];
    },
    setMyAddressesPage: function setMyAddressesPage(state, page) {
      state.addresses.mine.page = page;
    },
    setMyAddressesSort: function setMyAddressesSort(state, sort) {
      state.addresses.mine.sort = sort;
    },
    setMyAddressesSearch: function setMyAddressesSearch(state, search) {
      state.addresses.mine.search = search;
    },
    fillAddresses: function fillAddresses(state, data) {
      state.addresses.all.data = data;
    },
    clearAddresses: function clearAddresses(state) {
      state.addresses.all.data = [];
    },
    setAddressesPage: function setAddressesPage(state, page) {
      state.addresses.all.page = page;
    },
    setAddressesSort: function setAddressesSort(state, sort) {
      state.addresses.all.sort = sort;
    },
    setAddressesSearch: function setAddressesSearch(state, search) {
      state.addresses.all.search = search;
    },
    fillRequests: function fillRequests(state, data) {
      state.admin.requests.data = data;
    },
    setRequestsPage: function setRequestsPage(state, page) {
      state.admin.requests.page = page;
    },
    setRequestsSort: function setRequestsSort(state, sort) {
      state.admin.requests.sort = sort;
    },
    fillAddresses4Map: function fillAddresses4Map(state, data) {
      state.addresses4map = data;
    },
    fillMyAddresses4Map: function fillMyAddresses4Map(state, data) {
      state.myaddresses4map = data;
    },
    fillUsers4Map: function fillUsers4Map(state, data) {
      state.users4map = data;
    },
    fillArchives: function fillArchives(state, data) {
      state.archives.data = data;
    },
    setArchivesPage: function setArchivesPage(state, page) {
      state.archives.page = page;
    },
    setArchivesSort: function setArchivesSort(state, sort) {
      state.archives.sort = sort;
    },
    addressLoading: function addressLoading(state, value) {
      state.addresses.loading = value;
    },
    toggleAddressesAccess: function toggleAddressesAccess(state, value) {
      state.addresses.all.access = value;
    },
    toggleAddressesDone: function toggleAddressesDone(state, value) {
      state.addresses.all.done = value;
    },
    toggleAddressesGoogle: function toggleAddressesGoogle(state, value) {
      state.addresses.all.google = value;
    },
    toggleAddressesImages: function toggleAddressesImages(state, value) {
      state.addresses.all.images = value;
    },
    toggleMyAddressesDone: function toggleMyAddressesDone(state, value) {
      state.addresses.mine.done = value;
    },
    toggleMyAddressesGoogle: function toggleMyAddressesGoogle(state, value) {
      state.addresses.mine.google = value;
    },
    toggleMyAddressesImages: function toggleMyAddressesImages(state, value) {
      state.addresses.mine.images = value;
    },
    setMessage: function setMessage(state, payload) {
      if (!state.messages[payload._id]) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.messages, payload._id, [payload.message]);
      } else {
        if (state.messages[payload._id] > 100) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.messages, payload._id, [payload.message]);
        } else {
          state.messages[payload._id].push(payload.message);
        }
      }
    },
    setPdfMessage: function setPdfMessage(state, payload) {
      if (!state.pdfmessages[payload._id]) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.pdfmessages, payload._id, [payload.message]);
      } else {
        if (state.pdfmessages[payload._id] > 100) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.pdfmessages, payload._id, [payload.message]);
        } else {
          state.pdfmessages[payload._id].push(payload.message);
        }
      }
    },
    deleteMessages: function deleteMessages(state, id) {
      if (state.messages[id]) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.messages, id, []);
      }
    },
    deletePdfMessages: function deletePdfMessages(state, id) {
      if (state.pdfmessages[id]) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.pdfmessages, id, []);
      }
    },
    refreshAddress: function refreshAddress(state, payload) {
      if (payload.type === 'mine') {
        var index = state.addresses.mine.data.data.findIndex(function (add) {
          return add._id === payload.item._id;
        });
        if (index > -1) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.addresses.mine.data.data, index, payload.item);
        }
      } else {
        var _index = state.addresses.all.data.data.findIndex(function (add) {
          return add._id === payload.item._id;
        });
        if (_index > -1) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.addresses.all.data.data, _index, payload.item);
        }
      }
    }
  },
  actions: {
    login: function login(_ref, data) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('setLoading', true);
      return dispatch('logout').then(function (res) {
        return __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].authenticate({
          strategy: 'local',
          email: data.email,
          password: data.password
        }).then(function (response) {
          return grabAuthData(response, commit, dispatch);
        }).catch(function (error) {
          var meta = { error: true, success: false, info: false, warning: false };
          commit('setSnack', { error: error, meta: meta });
          commit('setLoading', false);
        });
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;

      commit('setLoading', true);
      commit('setPosInterval', null);
      __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].logout().then(function (response) {
        commit('setAuth', { token: null, user: null });
        commit('clearUsers');
        commit('setLoading', false);
        commit('setSnack', {
          error: {
            message: 'Sesiunea de lucru a fost inchisa. Sunteti in modul anonim.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
        commit('setLoading', false);
      });
    },
    attemptAuth: function attemptAuth(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          state = _ref3.state;

      __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].passport.getJWT().then(function (jwt) {
        if (jwt) {
          return state.feathers.authenticate({ strategy: 'jwt', accessToken: jwt });
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
      }).then(function (response) {
        if (response) {
          return grabAuthData(response, commit, dispatch);
        } else {
          commit('setLoading', false);
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
        commit('setLoading', false);
      });
    },
    toggleAdmin: function toggleAdmin(_ref4, data) {
      var dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          state = _ref4.state;

      state.services.users.patch(data._id, { admin: data.admin, roles: data.admin ? ['admin'] : ['user'] }).then(function (res) {
        dispatch('fetchUsers');
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. Utilizatorul ' + res.username + ' a fost ' + (res.admin ? 'promovat' : 'retrogradat') + '.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    checkEmail: function checkEmail(_ref5, email) {
      var state = _ref5.state;

      return state.services.users.find({ query: { email: email } });
    },
    deleteAllPhotos: function deleteAllPhotos(_ref6, photoIDs) {
      var dispatch = _ref6.dispatch;

      photoIDs.forEach(function (id) {
        dispatch('deletePhoto', id);
      });
    },
    deleteAllPdfs: function deleteAllPdfs(_ref7, pdfIDs) {
      var dispatch = _ref7.dispatch;

      pdfIDs.forEach(function (id) {
        dispatch('deletePdf', id);
      });
    },
    generateThumbs: function generateThumbs(_ref8, addressID) {
      var state = _ref8.state,
          commit = _ref8.commit;

      state.services.thumbgenerator.create({ id: addressID }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    setEventWatchers: function setEventWatchers(_ref9) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit,
          state = _ref9.state;

      state.services.users.on('created', function (user) {
        if (state.auth.user.admin) {
          dispatch('fetchUsers');
          dispatch('fetchUsers4Map');
        }
      });
      state.services.users.on('updated', function (user) {
        if (state.auth.user.admin) {
          dispatch('fetchUsers');
          dispatch('fetchUsers4Map');
        }
      });
      state.services.users.on('patched', function (user) {
        if (state.auth.user.admin) {
          dispatch('fetchUsers');
          dispatch('fetchUsers4Map');
        }
      });
      state.services.users.on('removed', function (user) {
        if (state.auth.user.admin) {
          dispatch('fetchUsers');
          dispatch('fetchUsers4Map');
        }
      });

      state.services.addresses.on('created', __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default()(function (address) {
        dispatch('fetchMyAddresses');
        dispatch('fetchAddresses');
        dispatch('fetchMyAddresses4Map');
        dispatch('fetchAddresses4Map');
      }, 1000, { 'maxWait': 1000 }));
      state.services.addresses.on('updated', __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default()(function (address) {
        dispatch('fetchMyAddresses');
        dispatch('fetchAddresses');
        dispatch('fetchMyAddresses4Map');
        dispatch('fetchAddresses4Map');
      }, 1000, { 'maxWait': 1000 }));
      state.services.addresses.on('patched', __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default()(function (address) {
        dispatch('fetchMyAddresses');
        dispatch('fetchAddresses');
        dispatch('fetchMyAddresses4Map');
        dispatch('fetchAddresses4Map');
      }, 1000, { 'maxWait': 1000 }));
      state.services.addresses.on('removed', __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default()(function (address) {
        dispatch('fetchMyAddresses');
        dispatch('fetchAddresses');
        dispatch('fetchMyAddresses4Map');
        dispatch('fetchAddresses4Map');
      }, 1000, { 'maxWait': 1000 }));

      state.services.requests.on('created', function (address) {
        if (state.auth.user.admin) {
          dispatch('fetchRequests');
        }
      });
      state.services.requests.on('updated', function (address) {
        if (state.auth.user.admin) {
          dispatch('fetchRequests');
        }
      });
      state.services.requests.on('patched', function (address) {
        if (state.auth.user.admin) {
          dispatch('fetchRequests');
        }
      });
      state.services.requests.on('removed', function (address) {
        if (state.auth.user.admin) {
          dispatch('fetchRequests');
        }
      });

      state.services.archives.on('created', function (address) {
        if (state.auth.user.admin) {
          dispatch('fetchArchives');
        }
      });
      state.services.archives.on('updated', function (address) {
        if (state.auth.user.admin) {
          dispatch('fetchArchives');
        }
      });
      state.services.archives.on('patched', function (address) {
        if (state.auth.user.admin) {
          dispatch('fetchArchives');
        }
      });
      state.services.archives.on('removed', function (address) {
        if (state.auth.user.admin) {
          dispatch('fetchArchives');
        }
      });

      state.services.messages.on('photo_saved', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: 'Poza ' + event.count + ' a fost salvata',
              type: 'success'
            }
          });
        }
      });
      state.services.messages.on('photo_error', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: 'Poza ' + event.count + ' nu a putut fi salvata...',
              type: 'error'
            }
          });
        }
      });
      state.services.messages.on('photo_count', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: 'Se salveaza ' + event.count + ' poze',
              type: 'info'
            }
          });
        }
      });
      state.services.messages.on('photo_now', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: 'Se salveaza poza ' + event.count + '!',
              type: 'info'
            }
          });
        }
      });
      state.services.messages.on('photo_thumb_error', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setMessage', {
            _id: event._id,
            message: {
              label: 'Eroare la thumbnail pt poza ' + event.count + '...',
              type: 'error'
            }
          });
        }
      });

      state.services.messages.on('pdf_saved', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setPdfMessage', {
            _id: event._id,
            message: {
              label: 'PDF-ul ' + event.count + ' a fost salvat',
              type: 'success'
            }
          });
        }
      });
      state.services.messages.on('pdf_error', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setPdfMessage', {
            _id: event._id,
            message: {
              label: 'PDF-ul ' + event.count + ' nu a putut fi salvat...',
              type: 'error'
            }
          });
        }
      });
      state.services.messages.on('pdf_count', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setPdfMessage', {
            _id: event._id,
            message: {
              label: 'Se salveaza ' + event.count + ' pdf-uri',
              type: 'info'
            }
          });
        }
      });
      state.services.messages.on('pdf_now', function (event) {
        if (event.user === state.auth.user._id) {
          commit('setPdfMessage', {
            _id: event._id,
            message: {
              label: 'Se salveaza pdf-ul ' + event.count + '!',
              type: 'info'
            }
          });
        }
      });
    },
    fetchUsers: function fetchUsers(_ref10) {
      var commit = _ref10.commit,
          state = _ref10.state;

      commit('setFetching', true);
      var query = {
        $skip: (state.admin.users.page - 1) * 10,
        $sort: state.admin.users.sort
      };
      if (state.admin.users.search.length) {
        query['orRegex'] = [{
          username: {
            $search: state.admin.users.search
          }
        }, {
          email: {
            $search: state.admin.users.search
          }
        }];
      }
      state.services.users.find({ query: query }).then(function (result) {
        commit('fillUsers', result);
        commit('setFetching', false);
      });
    },
    saveUser: function saveUser(_ref11, data) {
      var dispatch = _ref11.dispatch,
          commit = _ref11.commit,
          state = _ref11.state;

      state.services.users.create(data).then(function (res) {
        dispatch('fetchUsers');
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. Utilizator adaugat.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    updateUser: function updateUser(_ref12, data) {
      var dispatch = _ref12.dispatch,
          commit = _ref12.commit,
          state = _ref12.state;

      state.services.users.patch(data._id, data).then(function (res) {
        dispatch('fetchUsers');
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. Utilizator modificat.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    deleteUser: function deleteUser(_ref13, _ids) {
      var dispatch = _ref13.dispatch,
          commit = _ref13.commit,
          state = _ref13.state;

      state.services.users.remove(null, { query: { _id: { $in: _ids } } }).then(function (res) {
        dispatch('fetchUsers');
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. ' + res.length + ' utilizator(i) eliminat(i).'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    setUsersPage: function setUsersPage(_ref14, page) {
      var commit = _ref14.commit,
          dispatch = _ref14.dispatch;

      commit('setUsersPage', page);
      dispatch('fetchUsers');
    },
    setUsersSort: function setUsersSort(_ref15, sort) {
      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;

      commit('setUsersSort', sort);
      dispatch('fetchUsers');
    },
    setUsersSearch: function setUsersSearch(_ref16, search) {
      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;

      commit('setUsersSearch', search);
      dispatch('fetchUsers');
    },
    fetchMyAddresses: function fetchMyAddresses(_ref17) {
      var commit = _ref17.commit,
          state = _ref17.state;

      commit('setFetching', true);
      var query = {
        $skip: (state.addresses.mine.page - 1) * 10,
        $sort: state.addresses.mine.sort,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }],
        users: {
          $in: [state.auth.user._id]
        }
      };

      if (state.addresses.mine.google === -1) {
        query['google'] = {
          $exists: true
        };
        query['offset'] = {
          $eq: true
        };
      } else if (state.addresses.mine.google === 1) {
        query['google'] = {
          $exists: true
        };
        query['offset'] = {
          $eq: false
        };
      } else if (state.addresses.mine.google === 2) {
        query['google'] = {
          $exists: false
        };
      }

      if (state.addresses.mine.images === 1) {
        query['photos.0'] = {
          $exists: true
        };
      } else if (state.addresses.mine.images === -1) {
        query['photos.0'] = {
          $exists: false
        };
      }

      if (state.addresses.mine.done === 1) {
        query['done'] = {
          $in: [true, 'true']
        };
      } else if (state.addresses.mine.done === -1) {
        query['done'] = {
          $in: [false, 'false']
        };
      }

      if (state.addresses.mine.search.length) {
        query['orRegex'] = [{
          address: {
            $search: state.addresses.mine.search
          }
        }, {
          nrcrt: {
            $search: state.addresses.mine.search
          }
        }, {
          title: {
            $search: state.addresses.mine.search
          }
        }];
      }
      state.services.addresses.find({ query: query }).then(function (result) {
        commit('fillMyAddresses', result);
        commit('setFetching', false);
      });
    },
    refreshAddress: function refreshAddress(_ref18, _ref19) {
      var commit = _ref18.commit,
          state = _ref18.state;
      var id = _ref19.id,
          type = _ref19.type;

      commit('setFetching', true);
      var query = {
        _id: id,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }],
        users: {
          $in: [state.auth.user._id]
        }
      };
      state.services.addresses.find({ query: query }).then(function (result) {
        if (result.data[0]) {
          commit('refreshAddress', { item: result.data[0], type: type });
          commit('setFetching', false);
        }
      });
    },
    darnicie: function darnicie(_ref20, payload) {
      var state = _ref20.state,
          commit = _ref20.commit;

      state.services.addresses.patch(null, {
        $push: {
          users: {
            $each: payload
          }
        }
      }).then(function (res) {
        commit('setSnack', {
          error: {
            message: 'Operatiune efectuata cu succes!'
          },
          meta: {
            error: false,
            success: false,
            info: true,
            warning: false
          }
        });
      }).catch(function (err) {
        console.log(err);
        commit('setSnack', {
          error: {
            message: 'A aparut o eroare la procesarea cererii...'
          },
          meta: {
            error: true,
            success: false,
            info: false,
            warning: false
          }
        });
      });
    },
    calicie: function calicie(_ref21, payload) {
      var state = _ref21.state,
          commit = _ref21.commit;

      state.services.addresses.patch(null, {
        $pull: {
          users: {
            $in: payload
          }
        }
      }).then(function (res) {
        commit('setSnack', {
          error: {
            message: 'Operatiune efectuata cu succes!'
          },
          meta: {
            error: false,
            success: false,
            info: true,
            warning: false
          }
        });
      }).catch(function (err) {
        console.log(err);
        commit('setSnack', {
          error: {
            message: 'A aparut o eroare la procesarea cererii...'
          },
          meta: {
            error: true,
            success: false,
            info: false,
            warning: false
          }
        });
      });
    },
    saveMyAddress: function saveMyAddress(_ref22, data) {
      var dispatch = _ref22.dispatch,
          commit = _ref22.commit,
          state = _ref22.state;

      commit('addressLoading', true);
      state.services.addresses.create(data).then(function (res) {
        commit('addressLoading', false);
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. Adresa adaugata.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        commit('addressLoading', false);
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    updateMyAddress: function updateMyAddress(_ref23, data) {
      var dispatch = _ref23.dispatch,
          commit = _ref23.commit,
          state = _ref23.state;

      commit('addressLoading', true);
      state.services.addresses.patch(data._id, data).then(function (res) {
        commit('addressLoading', false);
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. Adresa modificata.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        commit('addressLoading', false);
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    deleteMyAddress: function deleteMyAddress(_ref24, _ids) {
      var dispatch = _ref24.dispatch,
          commit = _ref24.commit,
          state = _ref24.state;

      if (typeof _ids === 'string') {
        state.services.addresses.remove(_ids).then(function (res) {
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. Adresa eliminata.'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          });
        }).catch(function (error) {
          var meta = { error: true, success: false, info: false, warning: false };
          commit('setSnack', { error: error, meta: meta });
        });
      } else {
        state.services.addresses.remove(null, { query: { _id: { $in: _ids } } }).then(function (res) {
          dispatch('fetchMyAddresses');
          commit('setSnack', {
            error: {
              message: 'Operatiune reusita. ' + res.length + ' adresa(e) eliminata(e).'
            },
            meta: {
              error: false,
              success: true,
              info: false,
              warning: false
            }
          });
        }).catch(function (error) {
          var meta = { error: true, success: false, info: false, warning: false };
          commit('setSnack', { error: error, meta: meta });
        });
      }
    },
    setMyAddressesPage: function setMyAddressesPage(_ref25, page) {
      var commit = _ref25.commit,
          dispatch = _ref25.dispatch;

      commit('setMyAddressesPage', page);
      dispatch('fetchMyAddresses');
    },
    setMyAddressesSort: function setMyAddressesSort(_ref26, sort) {
      var commit = _ref26.commit,
          dispatch = _ref26.dispatch;

      commit('setMyAddressesSort', sort);
      dispatch('fetchMyAddresses');
    },
    setMyAddressesSearch: function setMyAddressesSearch(_ref27, search) {
      var commit = _ref27.commit,
          dispatch = _ref27.dispatch;

      commit('setMyAddressesSearch', search);
      dispatch('fetchMyAddresses');
    },
    setAddressDone: function setAddressDone(_ref28, payload) {
      var state = _ref28.state,
          commit = _ref28.commit;

      commit('addressLoading', true);
      state.services.addresses.patch(payload.id, { done: payload.value }).then(function (res) {
        commit('addressLoading', false);
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. Adresa modificata.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        commit('addressLoading', false);
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    toggleAddressesAccess: function toggleAddressesAccess(_ref29, access) {
      var commit = _ref29.commit,
          dispatch = _ref29.dispatch;

      commit('toggleAddressesAccess', access);
      dispatch('fetchAddresses');
    },
    toggleAddressesDone: function toggleAddressesDone(_ref30, done) {
      var commit = _ref30.commit,
          dispatch = _ref30.dispatch;

      commit('toggleAddressesDone', done);
      dispatch('fetchAddresses');
    },
    toggleAddressesGoogle: function toggleAddressesGoogle(_ref31, google) {
      var commit = _ref31.commit,
          dispatch = _ref31.dispatch;

      commit('toggleAddressesGoogle', google);
      dispatch('fetchAddresses');
    },
    toggleAddressesImages: function toggleAddressesImages(_ref32, images) {
      var commit = _ref32.commit,
          dispatch = _ref32.dispatch;

      commit('toggleAddressesImages', images);
      dispatch('fetchAddresses');
    },
    toggleMyAddressesDone: function toggleMyAddressesDone(_ref33, done) {
      var commit = _ref33.commit,
          dispatch = _ref33.dispatch;

      commit('toggleMyAddressesDone', done);
      dispatch('fetchMyAddresses');
    },
    toggleMyAddressesGoogle: function toggleMyAddressesGoogle(_ref34, google) {
      var commit = _ref34.commit,
          dispatch = _ref34.dispatch;

      commit('toggleMyAddressesGoogle', google);
      dispatch('fetchMyAddresses');
    },
    toggleMyAddressesImages: function toggleMyAddressesImages(_ref35, images) {
      var commit = _ref35.commit,
          dispatch = _ref35.dispatch;

      commit('toggleMyAddressesImages', images);
      dispatch('fetchMyAddresses');
    },
    fetchAddresses: function fetchAddresses(_ref36) {
      var commit = _ref36.commit,
          state = _ref36.state;

      commit('setFetching', true);
      var query = {
        $skip: (state.addresses.all.page - 1) * 10,
        $sort: state.addresses.all.sort,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }]
      };

      if (state.addresses.all.google === -1) {
        query['google'] = {
          $exists: true
        };
        query['offset'] = {
          $eq: true
        };
      } else if (state.addresses.all.google === 1) {
        query['google'] = {
          $exists: true
        };
        query['offset'] = {
          $eq: false
        };
      } else if (state.addresses.all.google === 2) {
        query['google'] = {
          $exists: false
        };
      }

      if (state.addresses.all.images === 1) {
        query['photos.0'] = {
          $exists: true
        };
      } else if (state.addresses.all.images === -1) {
        query['photos.0'] = {
          $exists: false
        };
      }

      if (state.addresses.all.done === 1) {
        query['done'] = {
          $in: [true, 'true']
        };
      } else if (state.addresses.all.done === -1) {
        query['done'] = {
          $in: [false, 'false']
        };
      }

      if (state.addresses.all.access === 1) {
        query['users.0'] = {
          $exists: true
        };
      } else if (state.addresses.all.access === -1) {
        query['users.0'] = {
          $exists: false
        };
      }

      if (state.addresses.all.search.length) {
        query['orRegex'] = [{
          address: {
            $search: state.addresses.all.search
          }
        }, {
          nrcrt: {
            $search: state.addresses.all.search
          }
        }, {
          title: {
            $search: state.addresses.all.search
          }
        }];
      }
      state.services.addresses.find({ query: query }).then(function (result) {
        commit('fillAddresses', result);
        commit('setFetching', false);
      });
    },
    saveAddress: function saveAddress(_ref37, data) {
      var dispatch = _ref37.dispatch,
          commit = _ref37.commit,
          state = _ref37.state;

      state.services.addresses.create(data).then(function (res) {
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. Adresa adaugata.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    updateAddress: function updateAddress(_ref38, data) {
      var dispatch = _ref38.dispatch,
          commit = _ref38.commit,
          state = _ref38.state;

      state.services.addresses.patch(data._id, data).then(function (res) {
        commit('setSnack', {
          error: {
            message: 'Operatiune reusita. Adresa modificata.'
          },
          meta: {
            error: false,
            success: true,
            info: false,
            warning: false
          }
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    deleteAddress: function deleteAddress(_ref39, ids) {
      var state = _ref39.state,
          commit = _ref39.commit;

      state.services.addresses.remove(null, {
        query: {
          _id: {
            $in: ids
          }
        }
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    setAddressesPage: function setAddressesPage(_ref40, page) {
      var commit = _ref40.commit,
          dispatch = _ref40.dispatch;

      commit('setAddressesPage', page);
      dispatch('fetchAddresses');
    },
    setAddressesSort: function setAddressesSort(_ref41, sort) {
      var commit = _ref41.commit,
          dispatch = _ref41.dispatch;

      commit('setAddressesSort', sort);
      dispatch('fetchAddresses');
    },
    setAddressesSearch: function setAddressesSearch(_ref42, search) {
      var commit = _ref42.commit,
          dispatch = _ref42.dispatch;

      commit('setAddressesSearch', search);
      dispatch('fetchAddresses');
    },
    requestAccess: function requestAccess(_ref43, id) {
      var state = _ref43.state,
          commit = _ref43.commit;

      state.services.requests.create({
        address: id,
        user: state.auth.user._id
      }).then(function (result) {
        commit('setSnack', {
          error: {
            message: 'Cererea a fost inregistrata. Adresa va fi afisata in lista d-voastra de adrese in momentul in care veti primi access.'
          },
          meta: {
            error: false,
            success: false,
            info: true,
            warning: false
          }
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    fetchRequests: function fetchRequests(_ref44) {
      var commit = _ref44.commit,
          state = _ref44.state;

      commit('setFetching', true);
      var query = {
        $skip: (state.admin.requests.page - 1) * 10,
        $sort: state.admin.requests.sort,
        $populate: [{
          path: 'address',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'user',
          options: {
            sort: {
              'username': 1
            }
          }
        }]
      };
      state.services.requests.find({ query: query }).then(function (result) {
        commit('fillRequests', result);
        commit('setFetching', false);
      });
    },
    denyRequests: function denyRequests(_ref45, ids) {
      var state = _ref45.state,
          commit = _ref45.commit;

      state.services.requests.remove(null, {
        query: {
          _id: {
            $in: ids
          }
        }
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    approveRequests: function approveRequests(_ref46, ids) {
      var state = _ref46.state,
          commit = _ref46.commit;

      state.services.requests.find({ query: { _id: { $in: ids } } }).then(function (requests) {
        requests.data.forEach(function (request) {
          state.services.addresses.patch(request.address, {
            $push: {
              users: request.user
            }
          }).then(function (res) {
            state.services.requests.remove(null, {
              query: {
                _id: {
                  $in: [request._id]
                }
              }
            });
          }).catch(function (error) {
            var meta = { error: true, success: false, info: false, warning: false };
            commit('setSnack', { error: error, meta: meta });
          });
        });
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    setRequestsPage: function setRequestsPage(_ref47, page) {
      var commit = _ref47.commit,
          dispatch = _ref47.dispatch;

      commit('setRequestsPage', page);
      dispatch('fetchRequests');
    },
    setRequestsSort: function setRequestsSort(_ref48, sort) {
      var commit = _ref48.commit,
          dispatch = _ref48.dispatch;

      commit('setRequestsSort', sort);
      dispatch('fetchRequests');
    },
    savePhoto: function savePhoto(_ref49, photo) {
      var state = _ref49.state,
          dispatch = _ref49.dispatch,
          commit = _ref49.commit;

      photo.forEach(function (p, i) {
        if (i === 0) {
          state.services.photos.create(p).catch(function (error) {
            var meta = { error: true, success: false, info: false, warning: false };
            commit('setSnack', { error: error, meta: meta });
          });
        } else {
          setTimeout(function () {
            state.services.photos.create(p).catch(function (error) {
              var meta = { error: true, success: false, info: false, warning: false };
              commit('setSnack', { error: error, meta: meta });
            });
          }, i * 1000);
        }
      });
    },
    deletePhoto: function deletePhoto(_ref50, photoID) {
      var state = _ref50.state,
          commit = _ref50.commit;

      state.services.photos.remove(photoID).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    savePdf: function savePdf(_ref51, pdf) {
      var state = _ref51.state,
          dispatch = _ref51.dispatch,
          commit = _ref51.commit;

      pdf.forEach(function (p, i) {
        if (i === 0) {
          state.services.pdfs.create(p).catch(function (error) {
            var meta = { error: true, success: false, info: false, warning: false };
            commit('setSnack', { error: error, meta: meta });
          });
        } else {
          setTimeout(function () {
            state.services.pdfs.create(p).catch(function (error) {
              var meta = { error: true, success: false, info: false, warning: false };
              commit('setSnack', { error: error, meta: meta });
            });
          }, i * 1000);
        }
      });
    },
    deletePdf: function deletePdf(_ref52, pdfID) {
      var state = _ref52.state,
          commit = _ref52.commit;

      state.services.pdfs.remove(pdfID).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    removeUserFromAddress: function removeUserFromAddress(_ref53, ids) {
      var state = _ref53.state,
          commit = _ref53.commit;

      state.services.addresses.patch(ids.address, {
        $pull: {
          users: ids.user
        }
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    sendLocationInfo: function sendLocationInfo(_ref54, position) {
      var state = _ref54.state;
      var _position$coords2 = position.coords,
          lat = _position$coords2.latitude,
          lng = _position$coords2.longitude,
          accuracy = _position$coords2.accuracy;

      state.services.users.patch(state.auth.user._id, {
        location: {
          coords: {
            lat: lat, lng: lng, accuracy: accuracy
          },
          timestamp: new Date()
        }
      }).then(function (user) {
        if (accuracy < 100) {
          state.services.histories.create({
            user: user._id,
            coords: {
              lat: lat, lng: lng, accuracy: accuracy
            },
            timestamp: new Date()
          });
        }
      });
    },
    getUserHistory: function getUserHistory(_ref55, id) {
      var state = _ref55.state;

      return state.services.histories.find({
        query: {
          user: id,
          paginate: false,
          $sort: {
            timestamp: 1
          }
        }
      });
    },
    fetchUsers4Map: function fetchUsers4Map(_ref56) {
      var commit = _ref56.commit,
          state = _ref56.state;

      commit('setFetching', true);
      var query = {
        paginate: false
      };

      state.services.users.find({ query: query }).then(function (result) {
        commit('fillUsers4Map', result);
        commit('setFetching', false);
      });
    },
    fetchAddresses4Map: function fetchAddresses4Map(_ref57) {
      var commit = _ref57.commit,
          state = _ref57.state;

      commit('setFetching', true);
      var query = {
        paginate: false,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }]
      };

      state.services.addresses.find({ query: query }).then(function (result) {
        commit('fillAddresses4Map', result);
        commit('setFetching', false);
      });
    },
    fetchMyAddresses4Map: function fetchMyAddresses4Map(_ref58) {
      var commit = _ref58.commit,
          state = _ref58.state;

      commit('setFetching', true);
      var query = {
        paginate: false,
        $populate: [{
          path: 'photos',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'pdfs',
          options: {
            sort: {
              'createdAt': -1
            }
          }
        }, {
          path: 'users',
          options: {
            sort: {
              'username': 1
            }
          }
        }],
        users: {
          $in: [state.auth.user._id]
        }
      };

      state.services.addresses.find({ query: query }).then(function (result) {
        commit('fillMyAddresses4Map', result);
        commit('setFetching', false);
      });
    },
    triggerArchive: function triggerArchive(_ref59, _ref60) {
      var state = _ref59.state,
          commit = _ref59.commit;
      var start = _ref60.start,
          end = _ref60.end;

      return state.services.archives.create({ start: start, end: end });
    },
    fetchArchives: function fetchArchives(_ref61) {
      var state = _ref61.state,
          commit = _ref61.commit;

      commit('setFetching', true);
      var query = {
        $skip: (state.archives.page - 1) * 10,
        $sort: state.archives.sort
      };

      state.services.archives.find({ query: query }).then(function (result) {
        commit('fillArchives', result);
        commit('setFetching', false);
      });
    },
    deleteArchive: function deleteArchive(_ref62, ids) {
      var state = _ref62.state,
          commit = _ref62.commit;

      state.services.archives.remove(null, {
        query: {
          _id: {
            $in: ids
          }
        }
      }).catch(function (error) {
        var meta = { error: true, success: false, info: false, warning: false };
        commit('setSnack', { error: error, meta: meta });
      });
    },
    setArchivesSort: function setArchivesSort(_ref63, sort) {
      var commit = _ref63.commit,
          dispatch = _ref63.dispatch;

      commit('setArchivesSort', sort);
      dispatch('fetchArchives');
    },
    setArchivesPage: function setArchivesPage(_ref64, page) {
      var commit = _ref64.commit,
          dispatch = _ref64.dispatch;

      commit('setArchivesPage', page);
      dispatch('fetchArchives');
    },
    uploadXLSX: function uploadXLSX(_ref65, file) {
      var state = _ref65.state;

      return state.services.xlsx.create(file);
    }
  }
}));

function grabAuthData(response, commit, dispatch) {
  return __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].passport.verifyJWT(response.accessToken).then(function (result) {
    return __WEBPACK_IMPORTED_MODULE_4__feathers___["a" /* default */].service('users').get(result.userId);
  }).then(function (data) {
    commit('setAuth', { token: response.accessToken, user: data });
    commit('setSnack', {
      error: {
        message: 'Autentificare reusita. Sesiune de lucru pornita.'
      },
      meta: {
        error: false,
        success: true,
        info: false,
        warning: false
      }
    });
    dispatch('setEventWatchers');
    var lastPoint = null;
    var km = null;
    if (navigator.geolocation) {
      var geoWatch = setInterval(getLocation, 60000);
      commit('setPosInterval', geoWatch);
      getLocation();
    }

    function getLocation() {
      navigator.geolocation.getCurrentPosition(function (position) {
        if (lastPoint === null) {
          lastPoint = [position.coords.latitude, position.coords.longitude];
          dispatch('sendLocationInfo', position);
        } else {
          var currentPoint = [position.coords.latitude, position.coords.longitude];
          km = __WEBPACK_IMPORTED_MODULE_6_turf_distance___default()(lastPoint, currentPoint);
        }


        if (!km || km > 0.1) {
          dispatch('sendLocationInfo', position);
        }
        commit('setGeolocationPosition', position);
      }, function (err) {
        if (err.code === 1) {
          alert('Pentru ca aplicatia sa functioneze in conditii optime, va rugam sa permiteti accesul la pozitia d-voastra geografica!');
        } else if (err.code === 2) {
          alert('Sistemul d-voastra a raportat o eroare la incercarea de a gasi coordonatele d-voastra.');
        } else {}
      }, {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 10000
      });
    }
  }).catch(function (error) {
    var meta = { error: true, success: false, info: false, warning: false };
    commit('setSnack', { error: error, meta: meta });
    commit('setLoading', false);
  });
}

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vueg__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vueg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vueg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store___ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_throttle__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lazyload__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vueg_css_transition_min_css__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vueg_css_transition_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vueg_css_transition_min_css__);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_lazyload___default.a, {
  error: 'static/photo.png',
  loading: 'static/loading.gif'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vueg___default.a, __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */], { shadow: false, forwardAnim: 'fadeInRightBig', backAnim: 'fadeInLeftBig', duration: '0.5' });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBXHTApQxC7eBOhAUSi5kiniwnOdztCyKY',
    v: '3'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$throttle = __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$debounce = __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default.a;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store___["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var feathers = __webpack_require__(543);
var socketio = __webpack_require__(541);
var hooks = __webpack_require__(535);

var auth = __webpack_require__(527);
var io = __webpack_require__(571);

var socket = io('https://dec18.verdedata.ro', {
  transports: ['websocket']
});

var feathersClient = feathers().configure(socketio(socket, { timeout: 600000 * 60 })).configure(hooks()).configure(auth({ storage: localStorage }));

/* harmony default export */ __webpack_exports__["a"] = (feathersClient);

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorMessages; });
var errorMessages = {
  400: '(400) Eroare la procesarea cererii.',
  401: '(401) Autentificare esuata.',
  402: '(402) Eroare la procesrea platii.',
  403: '(403) Acces restrictionat.',
  404: '(404) Resursa negasita.',
  405: '(405) Apel nepermis.',
  406: '(406) Raspuns formatat gresit.',
  408: '(408) Timpul alocat operatiunii a fost depasit.',
  409: '(409) Conflict in procesarea cererii.',
  411: '(411) Cererea nu are o lungime definita.',
  422: '(422) Cerere ce nu poate fi procesata.',
  429: '(429) Prea multe cereri.',
  500: '(500) Eroare generala',
  501: '(501) Metoda de procesare neimplementata.',
  502: '(502) Eroare de server.',
  503: '(503) Server indisponibil.'
};

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Index__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Index___default.a,
    meta: { requiresAuth: true }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login___default.a,
    meta: { requiresAnonymous: true }
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_5__components_admin_Dashboard___default.a,
    meta: { requiresAuth: true, requiresAdmin: true }
  }]
});

router.beforeEach(function (to, from, next) {
  var watcher = void 0;
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getLoading) {
    watcher = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].watch(function (state) {
      return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getLoading;
    }, function (loading) {
      proceed();
    });
  } else {
    proceed();
  }

  function proceed() {
    if (watcher) {
      watcher();
    }
    if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    })) {
      var user = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getUser;
      if (user) {
        if (to.matched.some(function (record) {
          return record.meta.requiresAdmin;
        })) {
          if (user.admin) {
            next();
          } else {
            next({ name: 'Login' });
          }
        } else {
          next();
        }
      } else {
        next({ name: 'Login' });
      }
    } else if (to.matched.some(function (record) {
      return record.meta.requiresAnonymous;
    })) {
      var _user = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getUser;
      if (_user) {
        next({ name: 'Index' });
      } else {
        next();
      }
    } else {
      next;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout_vue__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Layout_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'tud-layout': __WEBPACK_IMPORTED_MODULE_0__components_Layout_vue___default.a
  },
  computed: {
    light: function light() {
      return this.$store.getters.appLight;
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('attemptAuth').then(function (logged) {
      if (_this.$store.state.auth.user) {
        if (_this.$store.state.auth.user.admin) {
          _this.$router.replace({ name: 'Dashboard' });
        } else {
          _this.$router.replace({ name: 'Index' });
        }
      }
    });
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    light: function light() {
      return this.$store.getters.appLight;
    },
    clipped: function clipped() {
      return this.$store.getters.appClipped;
    },

    miniVariant: {
      get: function get() {
        return this.$store.getters.appMini;
      },
      set: function set() {
        this.$store.commit('toggleMini');
      }
    },
    drawer: {
      get: function get() {
        return this.$store.getters.appDrawer;
      },
      set: function set() {}
    },
    items: function items() {
      return this.$store.getters.appMenuItems;
    },
    auth: function auth() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    change: function change(val) {
      val ? this.$store.commit('openDrawer') : this.$store.commit('closeDrawer');
    },
    toggleLight: function toggleLight() {
      this.$store.commit('toggleLight');
    },
    displayLinkToRoute: function displayLinkToRoute(item) {
      return item.auth === undefined || item.auth === false && this.auth === null || item.auth && this.auth && !item.admin || item.auth && this.auth && item.admin && this.auth.admin;
    }
  }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'tud-my-addresses': function tudMyAddresses() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 667));
    },
    'tud-user-map-mine': function tudUserMapMine() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 669));
    },
    'tud-user-map-all': function tudUserMapAll() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 668));
    },
    'tud-all-addresses': function tudAllAddresses() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 666));
    }
  },
  data: function data() {
    return {
      tab: 1
    };
  },

  computed: {
    light: function light() {
      return this.$store.getters.appLight;
    }
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Drawer_vue__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Drawer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Drawer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Toolbar_vue__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Toolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Toolbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Snackbar_vue__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Snackbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Snackbar_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'tud-drawer': __WEBPACK_IMPORTED_MODULE_0__components_Drawer_vue___default.a,
    'tud-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_Toolbar_vue___default.a,
    'tud-footer': __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue___default.a,
    'tud-snack': __WEBPACK_IMPORTED_MODULE_3__components_Snackbar_vue___default.a
  },
  computed: {
    messages: function messages() {
      return this.$store.getters.snacksMessages;
    },
    visibleMessages: function visibleMessages() {
      return this.$store.getters.snacksVisible;
    }
  }
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showPassword: false,
      email: '',
      password: '',
      rules: {
        required: function required(value) {
          return !!value || 'Camp obligatoriu!';
        },
        email: function email(value) {
          var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'E-mail invalid!';
        }
      }
    };
  },

  computed: {
    light: function light() {
      return this.$store.getters.appLight;
    }
  },
  methods: {
    toggleShowPassword: function toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    login: function login() {
      var _this = this;

      if (!this.$refs.email.hasError && !this.$refs.password.hasError) {
        this.$store.dispatch('login', { email: this.email.toLowerCase(), password: this.password }).then(function () {
          var user = _this.$store.getters.getUser;
          if (user) {
            _this.email = '';
            _this.password = '';
            if (user.admin) {
              _this.$router.push({ name: 'Dashboard' });
            } else {
              _this.$router.push({ name: 'Index' });
            }
          }
        });
      }
    }
  },
  created: function created() {
    this.login = this.$throttle(this.login, 1000, { leading: true, trailing: false });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.email = '';
    this.password = '';
    next();
  }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    messages: {
      type: Array
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fakeMessage: {
        message: '',
        meta: {
          error: false,
          success: false,
          info: false,
          warning: false
        }
      }
    };
  },

  computed: {
    isVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        var _this = this;

        this.$store.commit('toggleSnacks', value);
        if (!value) {
          setTimeout(function () {
            _this.$store.commit('removeSnack');
            if (_this.messages.length) {
              setTimeout(function () {
                return _this.$store.commit('toggleSnacks', true);
              }, 500);
            }
          }, 500);
        }
      }
    },
    message: function message() {
      return this.messages.length ? this.messages.slice(0, 1)[0] : this.fakeMessage;
    }
  },
  methods: {
    clearAll: function clearAll() {
      this.$store.commit('clearMessages');
    }
  }
});

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    notifications: function notifications() {
      return this.$store.getters.getNotifications;
    },
    notificationsCount: function notificationsCount() {
      return this.notifications.length < 50 ? this.notifications.length : '50+';
    },
    user: function user() {
      return this.$store.getters.getUser;
    },
    fixed: function fixed() {
      return this.$store.getters.appFixed;
    },

    drawer: {
      get: function get() {
        return this.$store.getters.appDrawer;
      },
      set: function set(val) {
        val ? this.$store.commit('openDrawer') : this.$store.commit('closeDrawer');
      }
    }
  },
  methods: {
    logout: function logout() {
      var _this = this;

      this.$store.dispatch('logout').then(function () {
        _this.$router.replace({ name: 'Login' });
      });
    }
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'tud-users-card': function tudUsersCard() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 676));
    },
    'tud-addresses-card': function tudAddressesCard() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 670));
    },
    'tud-requests-card': function tudRequestsCard() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 674));
    },
    'tud-statuses-card': function tudStatusesCard() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 675));
    },
    'tud-map-card-users': function tudMapCardUsers() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 673));
    },
    'tud-map-card-addr': function tudMapCardAddr() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 672));
    },
    'tud-archives-card': function tudArchivesCard() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 671));
    }
  },
  data: function data() {
    return {
      tab: 1,
      display: {
        mode: 'list',
        icon: 'list',
        label: 'Display (*lista / tabel)'
      }
    };
  },

  computed: {
    light: function light() {
      return this.$store.getters.appLight;
    }
  },
  methods: {
    toggleDisplay: function toggleDisplay() {
      this.display.mode = this.display.mode === 'list' ? 'table' : 'list';
      this.display.icon = this.display.icon === 'list' ? 'grid_on' : 'list';
      this.display.label = 'Layout (' + (this.display.mode === 'list' ? '*lista / tabel' : 'lista / *tabel') + ')';
    }
  }
});

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  null,
  /* template */
  __webpack_require__(594),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(598),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    attrs: {
      "fixed": true
    }
  }, [_c('span', [_vm._v("© 2018 Verde Smart DATA")])])
},staticRenderFns: []}

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "align-self-stretch pb-5",
    attrs: {
      "xs12": "",
      "fill-height": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-x-transition",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.tab === 1) ? _c('tud-my-addresses') : _vm._e(), _vm._v(" "), (_vm.tab === 2) ? _c('tud-user-map-mine') : _vm._e(), _vm._v(" "), (_vm.tab === 3) ? _c('tud-user-map-all') : _vm._e(), _vm._v(" "), (_vm.tab === 4) ? _c('tud-all-addresses') : _vm._e()], 1), _vm._v(" "), _c('v-bottom-nav', {
    staticClass: "primary",
    attrs: {
      "shift": "",
      "value": "true"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('span', [_vm._v("Adresele mele")]), _vm._v(" "), _c('v-icon', [_vm._v("person_pin_circle")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 2
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_c('span', [_vm._v("Adr. mele")]), _vm._v(" "), _c('v-icon', [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 3
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_c('span', [_vm._v("Toate adr")]), _vm._v(" "), _c('v-icon', [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 4
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 4
      }
    }
  }, [_c('span', [_vm._v("Toate adresele")]), _vm._v(" "), _c('v-icon', [_vm._v("place")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": !_vm.light,
      "light": _vm.light
    }
  }, [_c('tud-layout')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "align-self-stretch pb-5",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.tab !== 5) ? _c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Panou de control")]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('tud-users-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 2) ? _c('tud-addresses-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 3) ? _c('tud-requests-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 4) ? _c('tud-statuses-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 5) ? _c('tud-map-card-users') : _vm._e(), _vm._v(" "), (_vm.tab === 6) ? _c('tud-map-card-addr') : _vm._e(), _vm._v(" "), (_vm.tab === 7) ? _c('tud-archives-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), _c('v-bottom-nav', {
    staticClass: "primary",
    attrs: {
      "shift": "",
      "value": "true"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('span', [_vm._v("Utilizatori")]), _vm._v(" "), _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 2
    },
    on: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_c('span', [_vm._v("Adrese")]), _vm._v(" "), _c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 3
    },
    on: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_c('span', [_vm._v("Cereri de access")]), _vm._v(" "), _c('v-icon', [_vm._v("lock")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 4
    },
    on: {
      "click": function($event) {
        _vm.tab = 4
      }
    }
  }, [_c('span', [_vm._v("Satus utilizatori")]), _vm._v(" "), _c('v-icon', [_vm._v("person_pin")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 5
    },
    on: {
      "click": function($event) {
        _vm.tab = 5
      }
    }
  }, [_c('span', [_vm._v("Useri")]), _vm._v(" "), _c('v-icon', [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 6
    },
    on: {
      "click": function($event) {
        _vm.tab = 6
      }
    }
  }, [_c('span', [_vm._v("Adrese")]), _vm._v(" "), _c('v-icon', [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 7
    },
    on: {
      "click": function($event) {
        _vm.tab = 7
      }
    }
  }, [_c('span', [_vm._v("Arhive")]), _vm._v(" "), _c('v-icon', [_vm._v("file_download")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "primary": ""
    }
  }, [_vm._v("lock")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Autentificare")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    ref: "email",
    attrs: {
      "rules": [_vm.rules.required, _vm.rules.email],
      "type": "email",
      "name": "email",
      "label": "Email",
      "id": "email",
      "prepend-icon": "email",
      "hint": "email"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "password",
    attrs: {
      "rules": [_vm.rules.required],
      "type": _vm.showPassword ? 'text' : 'password',
      "name": "password",
      "label": "Parola",
      "id": "password",
      "prepend-icon": "vpn_key",
      "hint": "parola",
      "append-icon": _vm.showPassword ? 'visibility' : 'visibility_off',
      "append-icon-cb": _vm.toggleShowPassword
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login($event)
      }
    }
  }, [_vm._v("Autentifica-te")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "primary white--text",
    attrs: {
      "fixed": _vm.fixed
    }
  }, [_c('v-avatar', {
    staticStyle: {
      "cursor": "pointer",
      "border": "2px solid white",
      "border-radius": "100%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logo.png"
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Verde Dec18")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.user) ? _c('v-chip', {
    staticClass: "transparent white--text",
    attrs: {
      "close": ""
    },
    on: {
      "input": _vm.logout
    }
  }, [_c('v-avatar', [_c('img', {
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('v-icon', {
    class: {
      'yellow--text': _vm.user.roles && _vm.user.roles.indexOf('tud-admin') !== -1
    }
  }, [_vm._v(_vm._s(_vm.user.admin ? 'star' : 'star_border'))]), _vm._v(" "), _c('span', {
    staticClass: "name-span"
  }, [_vm._v(" " + _vm._s(_vm.user.username))])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": 10000,
      "error": _vm.message.meta.error,
      "primary": _vm.message.meta.success,
      "info": _vm.message.meta.info,
      "warning": _vm.message.meta.warning,
      "multi-line": ""
    },
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [(_vm.message.meta.error) ? _c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("error")]) : _c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("info")]), _vm._v("\n  " + _vm._s(_vm.message.message) + "\n  "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Inchide mesajul'
      }),
      expression: "{ html: 'Inchide mesajul' }",
      arg: "left"
    }],
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: 'Goleste mesageria.'
      }),
      expression: "{ html: 'Goleste mesageria.' }",
      arg: "left"
    }],
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearAll($event)
      }
    }
  }, [_c('v-icon', [_vm._v("clear_all")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "mini-variant": _vm.miniVariant,
      "clipped": _vm.clipped,
      "value": _vm.drawer,
      "enable-resize-watcher": ""
    },
    on: {
      "input": _vm.change
    }
  }, [_c('v-list', [_c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.miniVariant = !_vm.miniVariant
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Meniu ingust")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleLight($event)
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "app-light"
  }, [_vm._v(_vm._s(!_vm.light ? 'lightbulb_outline' : 'wb_incandescent'))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Lumina")])], 1)], 1), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return (_vm.displayLinkToRoute(item)) ? _c('v-list-tile', {
      key: i,
      attrs: {
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tud-drawer'), _vm._v(" "), _c('tud-toolbar'), _vm._v(" "), _c('main', [_c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    key: _vm.$route.fullPath,
    attrs: {
      "column": "",
      "align-center": "",
      "child-flex": ""
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('tud-snack', {
    attrs: {
      "messages": _vm.messages,
      "visible": _vm.visibleMessages
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(235);
module.exports = __webpack_require__(234);


/***/ })

},[663]);


// WEBPACK FOOTER //
// static/js/app.cc1e2d497f1182957198.js